import React from 'react';
import styled from 'styled-components';

const Wrapper = ({ children }) => <StyledWrapper>{children}</StyledWrapper>;

export default Wrapper;

const StyledWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  width: 100%;
`;
